export default __webpack_public_path__ + "static/media/autopart.08a2382b.png";